/**
 * Returns a "mostly" unique id. Useful for dynamically generated HTML elements that need 'unique' Ids
 */
const generateMostlyUniqueId = () => Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
console.log(generateMostlyUniqueId);
module.exports = generateMostlyUniqueId;


// WEBPACK FOOTER //
// ./shared/scripts/generateMostlyUniqueId.js